(function() {
  'use strict';

  var SAFETY_TIMEOUT = 6000; // timeout fallback for hanging apps
  var REBUY_SETTLE = 12000; // window for late rebuy products
  var IMAGE_SETTLE = 2500;
  var MIN_LOADER_MS = 100; // floor, else the loader strobes
  var CFP_TEXT = 'Call for price';
  var productDataRequests = {};

  function getProductPath(link) {
    try {
      var url = new URL(link, window.location.origin);
      return url.pathname.replace(/\/$/, '');
    } catch (error) {
      return null;
    }
  }

  // one memoized request per product returns vendor + call-for-price.
  // rebuy has no metafield feed and .js omits metafields, so use an alt view.
  function getProductData(productPath) {
    if (!productDataRequests[productPath]) {
      productDataRequests[productPath] = fetch(productPath + '?view=card-data')
        .then(function(response) {
          if (!response.ok) throw new Error('product request failed');
          return response.json();
        })
        .then(function(data) {
          return { vendor: data.vendor || '', callForPrice: data.call_for_price === true };
        })
        .catch(function() {
          return { vendor: '', callForPrice: false };
        });
    }
    return productDataRequests[productPath];
  }

  // swap the rebuy price for the cfp label. marks the node so its idempotent
  // and re-applies if rebuy re-renders the price late.
  function applyCallForPrice(card) {
    var priceEl = card.querySelector('.rebuy-product-price') || card.querySelector('.rebuy-money');
    if (!priceEl || priceEl.getAttribute('data-rec-cfp') === '1') return;
    priceEl.setAttribute('data-rec-cfp', '1');
    priceEl.classList.add('rec-cfp');
    priceEl.textContent = CFP_TEXT;
  }

  function enrichRebuyCard(card, title, productPath) {
    getProductData(productPath).then(function(data) {
      // node may be detached
      if (!document.contains(card)) return;

      if (data.vendor && document.contains(title) && !card.querySelector('.rebuy-product-vendor')) {
        var vendorElement = document.createElement('p');
        vendorElement.className = 'rebuy-product-vendor';
        vendorElement.textContent = 'By ' + data.vendor;
        title.insertAdjacentElement('afterend', vendorElement);
      }

      if (data.callForPrice) applyCallForPrice(card);
    });
  }

  function enrichRebuyCards(wrap) {
    if (!wrap.querySelector('[data-rebuy-id]')) return;

    var titles = wrap.querySelectorAll('.rebuy-product-title');
    for (var i = 0; i < titles.length; i++) {
      var title = titles[i];
      var card = title.closest('.rebuy-product-block');
      var link = title.querySelector('a') || (card && card.querySelector('.rebuy-product-media a'));
      var productPath = link && getProductPath(link.href);

      if (!card || !productPath) continue;
      enrichRebuyCard(card, title, productPath);
    }
  }

  function observeRebuy(wrap) {
    if (wrap.__recRebuyObserver) return;

    var observer = new MutationObserver(function(mutations) {
      var isOnlyOurTags = true;
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1 && !added[j].classList.contains('rebuy-product-vendor')) {
            isOnlyOurTags = false;
            break;
          }
        }
        if (!isOnlyOurTags) break;
      }
      
      if (isOnlyOurTags) return;

      enrichRebuyCards(wrap);
      reconcileEmpty(wrap);
    });
    
    observer.observe(wrap, { childList: true, subtree: true });
    wrap.__recRebuyObserver = observer;

    setTimeout(function() {
      if (wrap.__recRebuyObserver) {
        wrap.__recRebuyObserver.disconnect();
        wrap.__recRebuyObserver = null;
      }
    }, REBUY_SETTLE);
  }

  // wrap is ready when widget or list is there
  function isWrapReady(wrap) {
    return !!(
      wrap.querySelector('.rebuy-widget-content') ||
      wrap.querySelector('.flickity-enabled') ||
      wrap.querySelector('.ProductList--grid')
    );
  }

  function hasVisibleProducts(wrap) {
    var rebuyWidget = wrap.querySelector('[data-rebuy-id]');
    if (rebuyWidget) {
      return !!rebuyWidget.querySelector('.rebuy-product-block');
    }
    return !!wrap.querySelector('.Carousel__Cell, .Grid__Cell');
  }

  function reconcileEmpty(wrap) {
    if (hasVisibleProducts(wrap)) {
      wrap.classList.remove('is-empty');
    } else {
      wrap.classList.add('is-empty');
    }
  }

  function whenImagesSettled(wrap, done) {
    var imgs = wrap.querySelectorAll('img');
    var pending = 0;
    var settled = false;
    var timer = null;

    function finish() {
      if (settled) return;
      settled = true;
      if (timer) clearTimeout(timer);
      done();
    }

    function one() {
      pending--;
      if (pending <= 0) finish();
    }

    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.complete || img.closest('.rec-loader')) continue;
      pending++;
      img.addEventListener('load', one, { once: true });
      img.addEventListener('error', one, { once: true });
    }

    if (pending === 0) return finish();
    timer = setTimeout(finish, IMAGE_SETTLE);
  }

  function reveal(wrap) {
    var held = Date.now() - (wrap.__recStart || 0);
    var wait = Math.max(0, MIN_LOADER_MS - held);
    setTimeout(function() { wrap.classList.add('is-loaded'); }, wait);
  }

  function markLoaded(wrap) {
    if (wrap.__recLoaded) return;
    wrap.__recLoaded = true;
    enrichRebuyCards(wrap);
    observeRebuy(wrap);

    reconcileEmpty(wrap);
    whenImagesSettled(wrap, function() { reveal(wrap); });

    if (wrap.__recObserver) { wrap.__recObserver.disconnect(); wrap.__recObserver = null; }
    if (wrap.__recTimer) { clearTimeout(wrap.__recTimer); wrap.__recTimer = null; }
  }

  function initWrap(wrap) {
    if (wrap.__recInit) return;
    wrap.__recInit = true;
    wrap.__recStart = Date.now();

    // already rendered
    if (isWrapReady(wrap)) {
      markLoaded(wrap);
      return;
    }

    var observer = new MutationObserver(function() {
      if (isWrapReady(wrap)) markLoaded(wrap);
    });
    
    observer.observe(wrap, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
    
    wrap.__recObserver = observer;

    wrap.__recTimer = setTimeout(function() {
      markLoaded(wrap);
    }, SAFETY_TIMEOUT);
  }

  function scan(root) {
    var scope = root || document;
    var wraps = scope.querySelectorAll ? scope.querySelectorAll('.rec-wrap[data-rec-loader]') : [];
    for (var i = 0; i < wraps.length; i++) initWrap(wraps[i]);
  }

  // first scan
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { scan(document); });
  } else {
    scan(document);
  }

  var root = document.body || document.documentElement;
  if (root && 'MutationObserver' in window) {
    var scanTimer = null;
    var lateObserver = new MutationObserver(function() {
      if (scanTimer) clearTimeout(scanTimer);
      scanTimer = setTimeout(function() {
        scan(document);
      }, 150);
    });
    lateObserver.observe(root, { childList: true, subtree: true });
  }
})();